export const camsTranslationPrefix = 'ui.registration-cams';

export const configKey = 'PRIVID_CONF';
export const camsUserIdStorageKey = 'CAMS_USER_ID';
export const camsSessionTokenSorageKey = 'CAMS_SESSION_TOKEN';
export const camsEnrollConsentKey = 'CAMS_ENROLL_CONSENT';
